export default class RodoAgreementsWFFMDataExchange {
  /**
   * 
   * @param {Element} form 
   */
  constructor (form) {
    this.agreements = form.querySelector('.form-submit-border').previousElementSibling
  }

  get data () {
    return this.agreements.querySelectorAll('.form-group').map((el, i) => ({
      id: i,
      name: this.agreementText(el),
      enabled: true,
      el: this.formGroupInput(el),
      selected: this.formGroupInput(el).checked,
      html: true,
    }))
  }

  /**
   * @param {Array} value
   */
  set data (value) {
    this.agreements.querySelectorAll('.form-group').forEach((el, i) => {
      const input = this.formGroupInput(el)

      if (value[i].selected) {
        input.setAttribute('checked', '')
        input.value = true
      } else {
        input.removeAttribute('checked')
        input.value = false
      }
    })
  }

  formGroupInput (group) {
    return group.querySelector('.checkbox input[type="checkbox"]')
  }

  agreementText (group) {
    const helpBlock = group.querySelector('.help-block:not(.field-validation-valid)')
    return helpBlock ? helpBlock.innerHTML : ''
  }
}



// WEBPACK FOOTER //
// ./src/services/RodoAgreementsWFFMDataExchange.js